import axiosInstance from './axiosInstance';
import { extractErrorMessage } from './errorUtils';

const BASE = 'techsavanna_pos.api.module_visibility_api';

const unwrap = (response) => {
  const data = response?.data?.message ?? response?.data ?? {};
  if (data && data.success === false) {
    throw new Error(data.message || data.error || 'Request failed');
  }
  return data;
};

export const fetchModuleVisibility = async (company) => {
  try {
    const res = await axiosInstance.get(`${BASE}.get_module_visibility`, {
      params: company ? { company } : undefined,
    });
    return unwrap(res);
  } catch (err) {
    throw new Error(extractErrorMessage(err));
  }
};

export const saveModuleVisibility = async ({ company, disabledModules }) => {
  try {
    const res = await axiosInstance.post(`${BASE}.update_module_visibility`, {
      company,
      // Backend accepts a JSON string or array; pass JSON to be safe across encoders.
      disabled_modules: JSON.stringify(disabledModules || []),
    });
    return unwrap(res);
  } catch (err) {
    throw new Error(extractErrorMessage(err));
  }
};
